import React from "react";
import PropTypes from 'prop-types';
import { FormGroup, Label, FormFeedback, CardImg } from 'reactstrap';
import RadioAnswer from "./radioAnswer";
import { beautyPipeline, beautyPipelineCeiling, removeChars } from "../../../helpers/hcutils";

const RadioQuestion = (props) => {
    let { question } = props;
    question = removeChars(question);
    if (!question.includes('?|')) question = question.replace('?', '?\n\n');
    if (question.includes('|') && question.includes('^')) {
        question = beautyPipelineCeiling(question);
    }
    if (question.includes('|')) {
        question = beautyPipeline(question);
    }
    return (
        <FormGroup>
            <Label for="selectOption" style={{ whiteSpace: 'pre-wrap' }} >
                {question}
            </Label>
            {
                props.image &&
                <figure className="figure d-block mx-auto" style={{ maxWidth: 'max-content' }}>
                    <CardImg src={require(`../../../assets/img/questions/${props.image}.jpg`)} alt="Question image" />
                </figure>
            }
            <div>
                {props.proposedanswers.map((proposedanswer) => <RadioAnswer
                    key={proposedanswer.validAnswerId}
                    answerid={proposedanswer.validAnswerId}
                    answer={proposedanswer.validAnswerText}
                    inline={props.inline ? true : false}
                    onChange={props.onChange}
                    value={proposedanswer.validAnswerId}
                    invalid={props.invalid}
                    checked={proposedanswer.validAnswerId === props.answer}
                />)}
            </div>
            {
                props.invalid && <FormFeedback style={{ display: "contents" }}>
                    Please select an answer!
                </FormFeedback>
            }
        </FormGroup >
    )
}

export default RadioQuestion;

RadioQuestion.defaultProps = {
    question: 'How many items are?',
    proposedanswers: [],
    inline: false,
    invalid: false
}

RadioQuestion.propTypes = {
    question: PropTypes.string,
    proposedanswers: PropTypes.array,
    inline: PropTypes.bool,
    onChange: PropTypes.func,
    invalid: PropTypes.bool
}
